import styled from 'styled-components';

export const PaypalButtonWrapper = styled.div`
  width: 100%;
`;

// Needed to give the button matching border radius to other payment buttons
export const PaypalButtonVisualContainer = styled.div`
  width: 100%;
  height: 2.9rem;
  border-radius: 0.5rem;
  overflow: hidden;
`;
